import API from "../api/manager";
import config from "../api/config";

const index = (query) => {
  return API({
    method: "GET",
    url: config.urls.party.index + query,
  });
};

const getParty = (id) => {
  return API({
    method: "GET",
    url: config.urls.party.get + `/${id}`,
  });
};

const approveParty = (id, data) => {
  return API({
    method: "POST",
    url: config.urls.party.approve + `/${id}`,
    data,
  });
};

const handleUpdateParty = (id, data) => {
  return API({
    method: "PUT",
    url: config.urls.party.updateParty + `/${id}`,
    data,
  });
};

const stats = (id) => {
  return API({
    method: "GET",
    url: config.urls.party.stats + `/${id}`,
  });
};

const partyStats = () => {
  return API({
    method: "GET",
    url: config.urls.party.partyStats,
  });
};

const getProfileParties = (query, id) => {
  return API({
    method: "GET",
    url: config.urls.party.profileParties + `/${id}` + query,
  });
};

const approvePartyStates = (id, duplicateDocumentNumCheck, data) => {
  return API({
    method: "POST",
    url: config.urls.party.approve + `/${id}/${duplicateDocumentNumCheck}`,
    data,
  });
};

const getDocumentsReport = (query) => {
  return API({
    method: "GET",
    url: config.urls.case.getDocumentsReport + query,
  });
};

const getPartyCodes = () => {
  return API({
    method: "GET",
    url: config.urls.party.getPartyCodes,
  });
};

const findByContract = (data) => {
  return API({
    method: "POST",
    url: config.urls.case.findByContract,
    data,
  });
};

export default {
  index,
  getParty,
  approveParty,
  stats,
  getProfileParties,
  partyStats,
  approvePartyStates,
  getDocumentsReport,
  getPartyCodes,
  handleUpdateParty,
  findByContract
};
